import { URLS } from '../../../constants';
import apiClient from '../../client';

const BillingGrids = {
    getBillingGrid: ({
        heading,
        roleId,
        type,
        assignedTo,
        pagination,
        order,
        filterValue,
        multipleFilterData,
        sortingKey,
        invoiceType,
        serachValue,
        noPagination = false,
        recordType = '',
        id = '',
        searchKey = '',
    }: {
        heading: string;
        roleId: string;
        type: string;
        assignedTo: string;
        pagination: {
            startIndex: number;
            noOfRecords: number;
        };
        order: string;
        filterValue: any;
        invoiceType?: any;
        multipleFilterData?: any;
        sortingKey?: any;
        serachValue?: any;
        searchKey?: any;
        noPagination?: boolean;
        recordType?: string;
        id?: string;
    }) => {
        let invoiceParams = {};
        if (recordType) {
            invoiceParams = {
                recordType,
                id,
            };
        }
        let otherFilterData = [];
        if (serachValue) {
            otherFilterData.push({
                filterKey: searchKey || '',
                filterValue: serachValue ? serachValue : '',
            });
        }
        if (typeof filterValue !== 'string') {
            otherFilterData = [...otherFilterData];
        } else if (typeof filterValue === 'string' && filterValue.length > 0) {
            otherFilterData.push({
                filterKey: '',
                filterValue: serachValue ? serachValue : '',
            });
        }
        return apiClient.post(URLS.billingRateGrid, {
            data: {
                heading,
                roleId,
                type,
                pagination,
                assignedTo,
                invoiceType, // Provide a default value if necessary
                multipleFilterData: multipleFilterData || [], // Ensure this is always an array
                filter: typeof filterValue !== 'string' ? filterValue : [], // Check type and provide default
                otherFilterData,
                sorting: {
                    order: order || 'DESC', // Default to 'DESC' if no order is provided
                    fieldName: sortingKey || 'startTime', // Default sorting field
                },
                noPagination,
                ...invoiceParams,
            },
        });
    },
    getBillingGridHistory: ({
        id,
        heading,
        roleId,
        type,
        assignedTo,
        pagination,
        order,
        name,
        filterValue,
        operationType,
    }: {
        id?: any;
        heading: string;
        roleId: string;
        type: string;
        assignedTo: string;
        pagination: {
            startIndex: number;
            noOfRecords: number;
        };
        name: string;
        order: string;
        filterValue: any;
        operationType?: any;
    }) =>
        apiClient.post(URLS.billingHistoryUrl, {
            data: {
                billingId: id,
                heading,
                roleId,
                type,
                pagination,
                assignedTo,
                operationType,
                filter:
                    typeof filterValue === 'string'
                        ? [
                              {
                                  filterKey: '',
                                  filterValue: filterValue || '',
                              },
                          ]
                        : filterValue,
                sorting: {
                    order: order || 'DESC',
                    fieldName: name || 'executedOn',
                },
            },
        }),
    deleteBillingGrid: ({
        billingId,
        deleteAll,
    }: {
        billingId: any;
        deleteAll: any;
    }) =>
        apiClient.post(URLS.deleteBillingGrid, {
            data: {
                billingId,
                deleteAll,
            },
        }),
    countBillingLines: ({ billingId }: { billingId: any }) =>
        apiClient.post(URLS.countBillingLines, {
            data: {
                billingId,
            },
        }),
    printStatements: ({
        clientId,
        billingIds,
    }: {
        clientId: any;
        billingIds: any;
    }) =>
        apiClient.post(URLS.billingStatementsUrl, {
            data: {
                clientId,
                billingIds,
            },
        }),
    globalSearch: (searchString: string, dateFilters: any) => {
        let dateRange = null;
        if (Object.keys(dateFilters).length) {
            dateRange = {
                startDate: dateFilters[0].filterValue,
                endDate: dateFilters[1].filterValue,
            };
        }
        return apiClient.post(URLS.globalBillingSearch, {
            data: {
                searchString,
                ...dateRange,
            },
        });
    },
    deleteBulkRecords: (billingIds: string[]) => {
        return apiClient.post(URLS.deleteBulkRecords, {
            data: {
                billingIds,
            },
        });
    },
    getBillingCodeFromBilling: () => {
        return apiClient.post(URLS.getBillingCodeFromBilling, {
            data: {},
        });
    },
    getAllBillingPatient: () => {
        return apiClient.post(URLS.getAllbillingPatient, {
            data: {},
        });
    },
    getProviderNamesFromBilling: () => {
        return apiClient.post(URLS.getProviderNamesFromBilling, {
            data: {},
        });
    },
};

export default BillingGrids;
